export default "__VITE_ASSET__TjNnEthd__"